import React from "react";
import { Reorder, useDragControls } from "framer-motion";
import { GripVertical, CheckCircle2, Clock, Sparkles, PenLine, Pencil, Trash2, Plus } from "lucide-react";

const SOURCE_BADGE = {
  ai: { label: "AI-generated", icon: Sparkles, cls: "bg-indigo-400/10 text-indigo-300" },
  manual: { label: "Manually edited", icon: PenLine, cls: "bg-emerald-400/10 text-emerald-300" },
  unset: { label: "Not started", icon: Clock, cls: "bg-slate-400/10 text-slate-400" },
};

export default function ChallengeDayRow({ day, locked, onEdit, onDelete, onInsertAfter }) {
  const dragControls = useDragControls();
  const badge = SOURCE_BADGE[day.source] || SOURCE_BADGE.unset;
  const BadgeIcon = badge.icon;

  return (
    <Reorder.Item value={day} dragListener={false} dragControls={dragControls} data-testid={`builder-day-row-${day.day}`}
      className="rounded-xl border border-white/[0.08] bg-[#131a29]/80 p-3 flex items-center gap-3">
      <button onPointerDown={(e) => !locked && dragControls.start(e)} disabled={locked} data-testid={`builder-day-drag-handle-${day.day}`}
        className={`shrink-0 ${locked ? "text-slate-700 cursor-not-allowed" : "text-slate-500 hover:text-white cursor-grab touch-none"}`}>
        <GripVertical className="w-4 h-4" />
      </button>
      <span className="shrink-0 text-xs font-bold text-white bg-white/5 rounded-full w-9 h-9 flex items-center justify-center">D{day.day}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-white truncate">{day.title}</p>
        <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase px-2 py-0.5 rounded-full mt-1 ${badge.cls}`}>
          <BadgeIcon className="w-3 h-3" /> {badge.label}
        </span>
        {day.reviewed && <span className="inline-flex items-center gap-1 text-[10px] font-bold text-emerald-300 ml-2"><CheckCircle2 className="w-3 h-3" /> Reviewed</span>}
      </div>
      {!locked && (
        <div className="flex items-center gap-1.5 shrink-0">
          <button onClick={() => onInsertAfter(day.day)} data-testid={`builder-day-insert-btn-${day.day}`} title="Insert new day below"
            className="text-slate-400 hover:text-white p-1.5 rounded-lg hover:bg-white/5"><Plus className="w-4 h-4" /></button>
          <button onClick={() => onEdit(day)} data-testid={`builder-day-edit-btn-${day.day}`} title="Edit this day"
            className="text-slate-400 hover:text-white p-1.5 rounded-lg hover:bg-white/5"><Pencil className="w-4 h-4" /></button>
          <button onClick={() => onDelete(day.day)} data-testid={`builder-day-delete-btn-${day.day}`} title="Delete this day"
            className="text-slate-400 hover:text-red-400 p-1.5 rounded-lg hover:bg-white/5"><Trash2 className="w-4 h-4" /></button>
        </div>
      )}
      {locked && (
        <button onClick={() => onEdit(day)} data-testid={`builder-day-view-btn-${day.day}`}
          className="text-xs font-semibold text-slate-400 hover:text-white shrink-0">View</button>
      )}
    </Reorder.Item>
  );
}
